import { browser } from "@utils/support";
import { writable } from "svelte/store";

const nluSessionId = writable();
nluSessionId.subscribe((value) => {
  if (value && browser) {
    window.parent.postMessage(
      `speakeasy:notify:sessionchange=${JSON.stringify({
        sessionId: value
      })}`,
      "*"
    );
  }
});

export default nluSessionId;
